// frontend/src/services/kpiGenericApi.js
import axios from 'axios';

export const getHourlyHeatmap = (client = 'ALL', hours = 24, excludedClients = '') =>
    axios.get('/api/kpi-generic/hourly-heatmap', { params: { client, hours, excludedClients } })
        .then(r => r.data);

export const getDispatchPerformance = (client = 'ALL', windowHours = 24, excludedClients = '') =>
    axios.get('/api/kpi-generic/dispatch-performance', { params: { client, windowHours, excludedClients } })
        .then(r => r.data);

export const getDispatchControlBoard = (params = {}) =>
    axios.get('/api/kpi-generic/dispatch-control-board', { params })
        .then(r => r.data);

export const getDispatchControlBoardSettings = () =>
    axios.get('/api/kpi-generic/dispatch-control-board/settings')
        .then(r => r.data);

export const updateDispatchControlBoardSettings = (payload = {}) =>
    axios.put('/api/kpi-generic/dispatch-control-board/settings', payload)
        .then(r => r.data);

export const sendTestDispatchKpiReport = (payload = {}) =>
    axios.post('/api/kpi-generic/dispatch-control-board/send-test-report', payload)
        .then(r => r.data);

export const downloadTestDispatchKpiReport = (payload = {}) =>
    axios.post('/api/kpi-generic/dispatch-control-board/download-test-report', payload, {
        responseType: 'blob',
    });

export async function getKpiClients() {
    const { data } = await axios.get('/api/kpi-generic/clients');
    return data; // { success, clients: [ 'Client A', ... ] }
}

export const rebuildHourly = (hours=24) =>
  axios.post('/api/kpi-generic/rebuild-hourly', null, { params: { hours } })
       .then(r => r.data);
